/* eslint-disable import/no-relative-packages */

import { sprintf } from '../../vendor/sprintf-js';

export function sleep(milliseconds) {
  return new Promise((resolve) => { setTimeout(resolve, 1000 * milliseconds); });
}

export function secondsToText(durationFloat) {
  const duration = Math.floor(durationFloat || 0);

  const hours = Math.floor(duration / 3600);
  const minutes = Math.floor((duration - hours * 3600) / 60);
  const seconds = duration % 60;

  let durationText = sprintf('%d:%02d', minutes, seconds);
  if (hours > 0) {
    durationText = sprintf('%d:%02d:%02d', hours, minutes, seconds);
  }

  return durationText;
}

export function throttle(fn, param, ms) {
  let timeout;
  function clear() {
    if (timeout !== undefined) {
      clearTimeout(timeout);
    }
  }
  if (fn !== undefined && ms !== undefined) {
    timeout = setTimeout(() => fn(param), ms);
  } else {
    console.error('callback function and the timeout must be supplied');
  }

  // API to clear the timeout
  throttle.clearTimeout = () => {
    clear();
  };
}

// export function fixGoogleMapsWebStyles(direction) {
//   if (direction === undefined) {
//     document.getElementById('google-maps-styling').innerHTML = '';
//     return;
//   }

//   if (direction === 'column') {
//     document.getElementById('google-maps-styling').innerHTML = `
// <style type="text/css">
// div div a[target='_blank'] div img[src*='google4'] {top: -20px !important;}
// div div a[target='_blank'] div img[src*='google5'] {top: -20px !important;}
// div div a[target='_blank'] div img[src*='google_white5'] {top: -20px !important;}
// div div a[target='_blank'] div img[src*='google_white6'] {top: -20px !important;}
// div.gm-style-cc div {bottom: 20px !important;}
// div.gm-bundled-control-on-bottom div.gmnoprint {top: -25px !important;}
// </style>
//   `;
//   } else {
//     document.getElementById('google-maps-styling').innerHTML = `
// <style type="text/css">
// div.gm-style-cc div {left: -20px !important;}
// div.gm-bundled-control-on-bottom div.gmnoprint {left: -20px !important;}
// </style>
//     `;
//   }
// }
